import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    FormLabel,
    Grid,
    Dialog,
    DialogContent,
    makeStyles,
} from '@material-ui/core';
import StringUtils from 'lib/StringUtils';
import DialogAppBar from 'components/widgets/modal/DialogAppBar';
import DisplayInput from 'components/modules/inventory/create/panels/DisplayInputNumber';
import InputNumberWithButton from 'components/widgets/InputNumberWithButton';

const useStyles = makeStyles((theme) => ({
    AppBar: {
        color: theme.palette.text.white,
        backgroundColor: theme.palette.background.sanMarino,
        '& h4': {
            color: theme.palette.text.white,
            fontSize: '15px',
        },
    },
    packFields: {
        padding: '10px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        rowGap: '15px',
        '& > div': {
            alignItems: 'center',
            paddingLeft: '5px',
            paddingRight: '5px',
        },
    },
}));

const FeesPanel = ({
    totalPack,
    data,
    onChange,
    bold,
    alignRight,
}) => {
    const classes = useStyles();
    const { packFields } = data;
    const [isPacksFormOpen, setIsPacksFormOpen] = useState(false);

    return (
        <>
            <Grid container item xs={12} sm={6}>
                <Grid
                    container
                    item
                    wrap="nowrap"
                    className={clsx({ 'justify-end': alignRight })}
                    xs={12}
                    sm={5}
                >
                    <FormLabel
                        className={clsx({ 'text-bold': bold })}
                    >
                        Pack:
                    </FormLabel>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <InputNumberWithButton
                        value={totalPack}
                        showCurrency
                        thousandSeparator
                        placeholder="$0.00"
                        onClick={() => setIsPacksFormOpen(true)}
                        size="sm"
                    />
                </Grid>
            </Grid>
            {isPacksFormOpen && (
                <Dialog
                    open
                    fullWidth
                    maxWidth="sm"
                    disableBackdropClick
                    disableEscapeKeyDown
                    scroll="paper"
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <DialogAppBar
                        appBarClassName={classes.AppBar}
                        title="Pack"
                        onClose={() => setIsPacksFormOpen(false)}
                        toolbarSize="md"
                    />
                    <DialogContent>
                        <div className={classes.packFields}>
                            <DisplayInput
                                label="Pack"
                                value={data.pack}
                                onChange={(value) => onChange('pack', value)}
                            />
                            {packFields
                                .filter((p) => !StringUtils.isEmpty(p.label)
                                    || (StringUtils.isEmpty(p.label) && Number(p.value ?? 0) !== 0))
                                .map(({
                                    entityMetadataId,
                                    label,
                                    value,
                                }) => (
                                    <DisplayInput
                                        key={entityMetadataId}
                                        disabled={StringUtils.isEmpty(label)}
                                        label={label ?? ''}
                                        value={Number(value ?? 0)}
                                        onChange={(val) => onChange('packField', val, { entityMetadataId })}
                                    />
                                ))}
                        </div>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

FeesPanel.propTypes = {
    totalPack: PropTypes.number,
    data: PropTypes.object,
    bold: PropTypes.bool,
    alignRight: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

FeesPanel.defaultProps = {
    totalPack: 0,
    data: {},
    bold: false,
    alignRight: false,
};

export default FeesPanel;
